// extracted by mini-css-extract-plugin
module.exports = {"isCopiedContainer":"IsCopiedMessage_isCopiedContainer__bapVl","active":"IsCopiedMessage_active__3ZH59"};